<template>
  <DateColumn :date="column.hires?.data[0]?.endDate" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import DateColumn from '@/components/GraphqlDataTable/columns/DateColumn.vue'

const EmploymentEndDateColumn = graphql(`
  fragment EmploymentEndDateColumn on Employment {
    hires {
      data {
        endDate
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentEndDateColumn> }>()
const column = computed(() => useFragment(EmploymentEndDateColumn, props.row))
</script>
